// A–Z by a name field, the way a person reads a list: ignoring case, ignoring punctuation and spacing (so
// "Deloitte - FR - A&A" sorts by its letters, after "Deloitte Argentina"), and treating digits as numbers (so "Team 2"
// comes before "Team 10"). A missing name sorts first rather than breaking the list. Returns a new array.
const collator = new Intl.Collator(undefined, { sensitivity: "base", numeric: true, ignorePunctuation: true });

export const sortByLabel = (items, labelKey) =>
  [...(items ?? [])].sort((a, b) => collator.compare(String(a?.[labelKey] ?? ""), String(b?.[labelKey] ?? "")));

export default sortByLabel;
